export const DEFAULT_STITUFY_LOGO_LIGHT = '/branding/stitufy-logo-light.png'
export const DEFAULT_STITUFY_LOGO_DARK = '/branding/stitufy-logo-dark.png'
